import { useNewTranslations } from '@/common/translations';
import { ErrorMessage } from '@/ui/components';

export default function NoDataError() {
  const translate = useNewTranslations();

  return (
    <ErrorMessage
      className="h-[351px] w-full px-4"
      title={translate('PreMatchStats.NoDataAvailable')}
      description={translate('PreMatchStats.NoDataAvailableDetails')}
    />
  );
}
